'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var nthHookTheme = require('@narvar/nth-hook-theme');

var _transforms;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var points = ['10', '1.86321757', '8.10810809', '0', '0', '7.98521826', '8.10810809', '15.9704364', '10', '14.1072189', '3.78378374', '7.98521826'].join(' ');
var Svg = styled.svg.withConfig({
  componentId: "sc-1e8qjzo-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    width: '1rem',
    height: 'auto',
    fill: s && s.color || '#000',
    verticalAlign: 'middle'
  }, s);
});
(function (Direction) {
  Direction["Up"] = "up";
  Direction["Down"] = "down";
  Direction["Left"] = "left";
  Direction["Right"] = "right";
})(exports.Direction || (exports.Direction = {}));
var transforms = (_transforms = {}, _defineProperty(_transforms, exports.Direction.Up, 'translate(8, 4) rotate(90 4 4)'), _defineProperty(_transforms, exports.Direction.Down, 'translate(0, 8) rotate(270 4 4)'), _defineProperty(_transforms, exports.Direction.Left, 'translate(0, 0) rotate(0 4 4)'), _defineProperty(_transforms, exports.Direction.Right, 'translate(4, 8) rotate(180 4 4)'), _transforms);
var Chevron = function Chevron(_ref2) {
  var s = _ref2.s,
    direction = _ref2.direction;
  var _useTheme = nthHookTheme.useTheme(),
    iconsPrimaryNone = _useTheme.iconsPrimaryNone;
  return /*#__PURE__*/React.createElement(Svg, {
    role: "img",
    style: _objectSpread(_objectSpread({}, iconsPrimaryNone), s),
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: points,
    transform: transforms[direction || exports.Direction.Left]
  }));
};
Chevron.defaultProps = {
  direction: exports.Direction.Left,
  s: {}
};
Chevron.propTypes = {
  direction: PropTypes.oneOf(Object.values(exports.Direction)),
  s: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired)
};
var index = nthHookTheme.withThemeProvider(Chevron, {
  themeTokens: ['iconsPrimaryNone']
});

exports.default = index;
